import React from 'react'
import { isFlagOn, K12_CORE_CURRICULUM_SERVICE_FLAG } from 'utils/featureFlags'

import OffWithSiteContext from './flag.off'
import OnWithSiteContext from './flag.on'

/**
 * Flag-switched HOC factory for site context.
 *
 * LEARN-28473 on: course-scoped LMS ensure via createCourseInstanceByCourse
 * LEARN-28473 off: legacy instructor/me ensure via userContextB64
 *
 * Drop-in replacement — same signature as the previous withSiteContext export.
 * Uses a render-time flag check (FlagsComponentRouter cannot wrap HOC factories).
 */
export default function withSiteContext(Component, options) {
  const OnWrapped = OnWithSiteContext(Component, options)
  const OffWrapped = OffWithSiteContext(Component, options)

  function FlaggedWithSiteContext(props) {
    if (isFlagOn([K12_CORE_CURRICULUM_SERVICE_FLAG])) {
      return <OnWrapped {...props} />
    }
    return <OffWrapped {...props} />
  }

  FlaggedWithSiteContext.displayName = `withSiteContext(${Component.displayName ||
    Component.name ||
    'Component'})`

  return FlaggedWithSiteContext
}
